const handlers = /* @__PURE__ */ new Map();
const wsClickOutside = {
  bind: (containerElm, binding, vnode) => {
    const handler = (event) => {
      if (containerElm !== event.target && !containerElm.contains(event.target) && (document.contains(event.target) || !searchInHistory(event, containerElm))) {
        vnode.context[binding.expression](event);
      }
    };
    handlers.set(containerElm, handler);
    document.body.addEventListener("click", handler);
  },
  unbind: (containerElm) => {
    document.body.removeEventListener("click", handlers.get(containerElm));
    handlers.delete(containerElm);
  }
};
function searchInHistory(event, containerElm) {
  var _a;
  const history = (_a = event.composedPath) == null ? void 0 : _a.call(event);
  if (!(history == null ? void 0 : history.includes)) {
    return false;
  }
  return history.includes(containerElm);
}
export {
  wsClickOutside
};
//# sourceMappingURL=clickOutside.es.js.map
